var img = "data:image/svg+xml,%3csvg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M11 11H22V16H27V27H16V22H11V11Z' fill='currentColor'/%3e%3c/svg%3e";
  export default img;